<div class="modal active">
  <div class="modal__container modal__container--sm">
      <div class="fields">
        <h2>Processing Tool Options</h2>
        <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  name="ngFlightInspectionForm" #ngForm="ngForm" id="flightInspectionForm" class="active">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Flight Inspection Parameters</h4>
                  <span> </span>
                </div>

                <div class="input-fields">
                  <div>
                    <label for="">Signal Level threshold</label>
                    <input type="number" name="SignalLevelThreshold" [(ngModel)]="thresholdSL"/>
                  </div>
                  <div>
                    <label for="">Altitude Interval</label>
                    <input type="number" name="altitudeInterval" [(ngModel)]="altitudeIncrement"/>
                  </div>
                </div>
                <div class="dropdown-fields">
                    <div>
                      <label for="">Vertical Reference</label>
                      <select required name="verticalReference" [(ngModel)]="verticalReference">
                        <option>AMSL</option>
                        <option>GPS</option>
                      </select>
                    </div>
                  </div>
              </div>
            </div>
            <div class="fields__btn">
              <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid"
              (click)="ok()">
                OK
              </button>
              <button class="gray" (click)="cancel()">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
